import React, { useContext, useState } from "react";
import stylesCss, { useStyles } from "./style";
import {
  Stepper,
  Step,
  StepLabel,
  Grid,
  Card,
  CardContent,
  Button,
} from "@mui/material";
import StepOne from "./stepOne";
import StepTwo from "./stepTwo";
import StepThree from "./stepThree";
import { ContactContext } from "../../../../context/contact/ContactContext";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import StepZero from "./stepZero";
import StepFour from "./stepFour";

const steps = [
  // "Seleccione empresa",
  "Busca tu empresa",
  "Información de empresa",
  "Usuario Primario",
  "Completado",
];

const ApprovalFlow = () => {
  const { t } = useTranslation();
  let navigate = useNavigate();
  const classes = useStyles();
  const {
    approvalSent,
    primaryContact,
    primaryContactCreated,
    secondContactCreated,
    created,
    enrollment,
    setStartEnrollment,
  } = useContext(ContactContext);
  const classesSx = stylesCss;
  const [activeStep, setActiveStep] = useState(1);
  const navigateEnrollment = async () => {
    await Promise.all([setStartEnrollment(true)]);
    let path = `/Vendor/Enrollment`;
    navigate(path);
  };
  if (enrollment) {
    console.log(enrollment);
    navigateEnrollment();
  }
  return (
    <>
      <Grid container spacing={2} padding={2}>
        <Grid item xs={12} md={12} lg={12}>
          <Grid container spacing={5}>
            <Grid item xs={12} md={6} lg={1}></Grid>
            <Grid item xs={12} md={12} lg={10}>
              <Card className={classes.cssCard}>
                <CardContent>
                  <br />
                  <Stepper sx={classesSx.root} activeStep={activeStep}>
                    {steps.map((label, index) => {
                      return (
                        <Step key={label}>
                          <StepLabel>{/* {label} {index} */}</StepLabel>
                        </Step>
                      );
                    })}
                  </Stepper>
                  <br />
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={12} lg={12}>
                      <Grid container spacing={5}>
                        <Grid item xs={12} md={6} lg={1}></Grid>
                        <Grid item xs={12} md={12} lg={10}>
                          {activeStep === 1 ? (
                            <StepOne setActiveStep={setActiveStep} />
                          ) : activeStep === 2 ? (
                            <StepTwo setActiveStep={setActiveStep} />
                          ) : activeStep === 3 ? (
                            <StepThree setActiveStep={setActiveStep} />
                          ) : //ingresa la documentación (Doc. afiliación al IESS)
                          activeStep === 4 ? (
                            <StepFour setActiveStep={setActiveStep} />
                          ) : //crea un Contacto secundario del proveedor
                          approvalSent &&
                            secondContactCreated &&
                            Object.keys(primaryContact).length > 0 ? (
                            <>
                              <br />
                              <h1>{t("finished")}</h1>
                              <br />
                              <br />
                              <h3>
                                {t("approvalMessageTo", {
                                  ApproverName:
                                    primaryContact.givenName +
                                    " " +
                                    primaryContact.surname,
                                }) +
                                  " " +
                                  t("notificationMessage")}
                              </h3>
                              <br />
                            </>
                          ) : //se crea un Contacto Primario del proveedor
                          approvalSent && primaryContactCreated ? (
                            <>
                              <br />
                              <h1>{steps[3]}</h1>
                              <br />
                              <br />
                              <h3>
                                {t("approvalMessage") +
                                  " " +
                                  t("notificationMessage")}
                              </h3>
                              <br />
                            </>
                          ) : (
                            <>
                              <br />
                              <h1>{t("finished")}</h1>
                              <br />
                              <br />
                              <h3>{t("errorMessage")}</h3>
                              <br />
                            </>
                          )}
                        </Grid>
                        <Grid item xs={12} md={6} lg={1}></Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                  <br />
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} md={6} lg={1}></Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default ApprovalFlow;
